import { render } from "./CategoryNavigation.vue?vue&type=template&id=2dc8a7ce&scoped=true"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js"

import "./CategoryNavigation.vue?vue&type=style&index=0&id=2dc8a7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc8a7ce"]])

export default __exports__